import React from 'react';
import { motion, transform } from 'motion/react';

import { useGetParams } from '../../hooks/useGetParams';

import { BgVideo } from '../BgVideo/BgVideo';
import { AdvtBgVideo } from '../AdvtBgVideo/AdvtBgVideo';
import { WordAnimator } from '../WordAnimator/WordAnimator';

import styles from './AdvtFullSize.module.css';

import letter_t1 from '../../assets/images/letters/t1.png';
import letter_r1 from '../../assets/images/letters/r.png';
import letter_a from '../../assets/images/letters/a.png';
import letter_k from '../../assets/images/letters/k.png';
import letter_t2 from '../../assets/images/letters/t2.png';
import letter_o from '../../assets/images/letters/o.png';
import letter_r2 from '../../assets/images/letters/r.png';

export const AdvtFullSize = React.memo(() => {
  const { sizeQR, qrCode1, qrCode2, title } = useGetParams();

  // const advtlines = title?.split(/\\n/)?.map((l) => l.trim());
  const initDelay = 3.5;

  const duration = 2;
  const delay = 0.066;

  const initDelayLetters = 1;

  const letters = [
    {
      src: letter_t1,
      width: 183,
      height: 145,
    },
    {
      src: letter_r1,
      width: 117,
      height: 115,
      translateX: '60px',
    },
    {
      src: letter_a,
      width: 125,
      height: 115,
      translateX: '15px',
    },
    {
      src: letter_k,
      width: 132,
      height: 115,
      translateX: '-15px',
    },
    {
      src: letter_t2,
      width: 98,
      height: 115,
      translateX: '-52px',
      zIndex: 10,
    },
    {
      src: letter_o,
      width: 118,
      height: 115,
      translateX: '-90px',
    },
    {
      src: letter_r2,
      width: 117,
      height: 115,
      translateX: '-120px',
    },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.firstLineBlock}>
        <div>
          {letters.map(
            ({ src, width, height, translateX = '100px', zIndex = 1 }, idx) => (
              <motion.img
                className={styles.letter}
                initial={{ rotateY: -90, opacity: 0, x: translateX }}
                animate={{
                  rotateY: [-90, 0, 0, 90],
                  opacity: [0, 1, 1, 0],
                }}
                transition={{
                  rotateY: {
                    duration,
                    delay: delay * idx + initDelayLetters,
                    ease: 'easeOut',
                    times: [0, 0.25, 0.75, 1],
                    repeat: 2,
                    repeatDelay: 0.3,
                  },

                  opacity: {
                    duration: duration,
                    delay: delay * idx + initDelayLetters,
                    ease: 'easeOut',
                    times: [0, 0.1, 0.9, 1],
                    repeat: 2,
                    repeatDelay: 0.3,
                  },
                }}
                src={src}
                alt=""
                width={width}
                height={height}
                key={src + idx}
                style={{ zIndex }}
              />
            ),
          )}
        </div>

        <motion.div
          className={styles.divider}
          initial={{ scale: 0, x: '-10rem', y: '2rem' }}
          animate={{ scale: [0, 1, 1, 0], x: '-10rem', y: '2rem' }}
          transition={{
            duration: 2.4,
            delay: 1,
            times: [0, 0.2, 0.8, 1],
            ease: 'easeOut',
            repeat: 2,
            repeatDelay: 0.2,
          }}
        >
          X
        </motion.div>
        <WordAnimator
          text={'ИКАР'}
          duration={2}
          delay={0.08}
          className={styles.firstLine}
          initDelay={0.8}
        />
      </div>

      <div className={styles.secondBlock}>
        <WordAnimator
          text={'участвуй'}
          className={styles.secondLine}
          initDelay={1.2}
          duration={1.9}
          delay={0.06}
        />
        <WordAnimator
          text={'в'}
          className={styles.secondLine}
          initDelay={1.2 + 0.5}
          duration={1.9}
          delay={0.06}
        />
        <WordAnimator
          text={'квизе'}
          className={styles.secondLine}
          initDelay={1.2 + 0.55}
          duration={1.9}
          delay={0.06}
        />
      </div>

      {/* {advtlines && (
        <motion.div
          animate={{ opacity: 0 }}
          transition={{ duration: 0.5, delay: 10 }}
          className={styles.titleBlock}
        >
          {advtlines[0] && (
            <WordAnimator text={advtlines[0]} className={styles.firstLine} />
          )}
          {advtlines[1] && (
            <WordAnimator
              text={advtlines[1]}
              className={styles.secondLine}
              initDelay={0.5}
            />
          )}
          {advtlines[2] && (
            <WordAnimator
              text={advtlines[2]}
              className={styles.thirdLine}
              initDelay={1}
            />
          )}
        </motion.div>
      )} */}

      <div className={styles.qrBlock}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              scale: {
                duration: 0.67,
                ease: 'easeOut',
                delay: initDelay + 5.2,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode1} alt="" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              scale: {
                duration: 0.67,
                ease: 'easeOut',
                delay: initDelay + 5.6,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
            }}
          >
            <img src={qrCode2} alt="" />
          </motion.div>
        )}
      </div>

      <BgVideo />
      {/* <AdvtBgVideo /> */}
    </div>
  );
});
